import { createLazyFileRoute } from "@tanstack/react-router";

import { UsersPage } from "@/features/admin/routes/Users";

export const Route = createLazyFileRoute("/_auth/admin/users/")({
  component: UsersPage,
});
